import { css, CSSResult } from 'lit'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'

export const cseFieldset = {
  gap: css`var(--cse-fieldset-gap, ${csSpacing.spacing06})`,
  alignItems: css`var(--cse-fieldset-align-items, stretch)`,
}

export const style: CSSResult = css`
  :host {
    display: block;
  }

  fieldset {
    border: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: ${cseFieldset.gap};
    align-items: ${cseFieldset.alignItems};
  }
`
